import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, Output, ContentChildren, forwardRef } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, CollectionNestedOption } from 'devextreme-angular/core';

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeAnimationComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeAnimationComponent extends NestedOption {
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeAnimationComponent,
      selectors: [["dxo-linear-gauge-animation"]],
      inputs: {
        duration: "duration",
        easing: "easing",
        enabled: "enabled"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeAnimationComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeAnimationModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeAnimationModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeBackgroundColorComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeBackgroundColorComponent extends NestedOption {
    get base() {
      return this._getOption('base');
    }
    set base(value) {
      this._setOption('base', value);
    }
    get fillId() {
      return this._getOption('fillId');
    }
    set fillId(value) {
      this._setOption('fillId', value);
    }
    get _optionPath() {
      return 'backgroundColor';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeBackgroundColorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeBackgroundColorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeBackgroundColorComponent,
      selectors: [["dxo-linear-gauge-background-color"]],
      inputs: {
        base: "base",
        fillId: "fillId"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeBackgroundColorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeBackgroundColorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeBackgroundColorModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeBackgroundColorModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeBackgroundColorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeBackgroundColorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeBackgroundColorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeBackgroundColorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeBorderComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeBorderComponent,
      selectors: [["dxo-linear-gauge-border"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeBorderComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeBorderModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeBorderModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeColorComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeColorComponent extends NestedOption {
    get base() {
      return this._getOption('base');
    }
    set base(value) {
      this._setOption('base', value);
    }
    get fillId() {
      return this._getOption('fillId');
    }
    set fillId(value) {
      this._setOption('fillId', value);
    }
    get _optionPath() {
      return 'color';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeColorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeColorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeColorComponent,
      selectors: [["dxo-linear-gauge-color"]],
      inputs: {
        base: "base",
        fillId: "fillId"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeColorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeColorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeColorModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeColorModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeColorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeColorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeColorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeColorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeExportComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeExportComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get fileName() {
      return this._getOption('fileName');
    }
    set fileName(value) {
      this._setOption('fileName', value);
    }
    get formats() {
      return this._getOption('formats');
    }
    set formats(value) {
      this._setOption('formats', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get printingEnabled() {
      return this._getOption('printingEnabled');
    }
    set printingEnabled(value) {
      this._setOption('printingEnabled', value);
    }
    get svgToCanvas() {
      return this._getOption('svgToCanvas');
    }
    set svgToCanvas(value) {
      this._setOption('svgToCanvas', value);
    }
    get _optionPath() {
      return 'export';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeExportComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeExportComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeExportComponent,
      selectors: [["dxo-linear-gauge-export"]],
      inputs: {
        backgroundColor: "backgroundColor",
        enabled: "enabled",
        fileName: "fileName",
        formats: "formats",
        margin: "margin",
        printingEnabled: "printingEnabled",
        svgToCanvas: "svgToCanvas"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeExportComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeExportComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeExportModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeExportModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeExportModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeExportModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeExportModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeExportModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeFontComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeFontComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get family() {
      return this._getOption('family');
    }
    set family(value) {
      this._setOption('family', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get weight() {
      return this._getOption('weight');
    }
    set weight(value) {
      this._setOption('weight', value);
    }
    get _optionPath() {
      return 'font';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeFontComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeFontComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeFontComponent,
      selectors: [["dxo-linear-gauge-font"]],
      inputs: {
        color: "color",
        family: "family",
        opacity: "opacity",
        size: "size",
        weight: "weight"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeFontComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeFontComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeFontModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeFontModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeFontModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeFontModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeFontModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeFontModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeFormatComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeFormatComponent extends NestedOption {
    get currency() {
      return this._getOption('currency');
    }
    set currency(value) {
      this._setOption('currency', value);
    }
    get formatter() {
      return this._getOption('formatter');
    }
    set formatter(value) {
      this._setOption('formatter', value);
    }
    get parser() {
      return this._getOption('parser');
    }
    set parser(value) {
      this._setOption('parser', value);
    }
    get precision() {
      return this._getOption('precision');
    }
    set precision(value) {
      this._setOption('precision', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useCurrencyAccountingStyle() {
      return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value) {
      this._setOption('useCurrencyAccountingStyle', value);
    }
    get _optionPath() {
      return 'format';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeFormatComponent,
      selectors: [["dxo-linear-gauge-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeFormatComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeFormatModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeFormatModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeGeometryComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeGeometryComponent extends NestedOption {
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get _optionPath() {
      return 'geometry';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeGeometryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeGeometryComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeGeometryComponent,
      selectors: [["dxo-linear-gauge-geometry"]],
      inputs: {
        orientation: "orientation"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeGeometryComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeGeometryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeGeometryModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeGeometryModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeGeometryModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeGeometryModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeGeometryModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeGeometryModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeLabelComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeLabelComponent extends NestedOption {
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get indentFromTick() {
      return this._getOption('indentFromTick');
    }
    set indentFromTick(value) {
      this._setOption('indentFromTick', value);
    }
    get overlappingBehavior() {
      return this._getOption('overlappingBehavior');
    }
    set overlappingBehavior(value) {
      this._setOption('overlappingBehavior', value);
    }
    get useRangeColors() {
      return this._getOption('useRangeColors');
    }
    set useRangeColors(value) {
      this._setOption('useRangeColors', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeLabelComponent,
      selectors: [["dxo-linear-gauge-label"]],
      inputs: {
        customizeText: "customizeText",
        font: "font",
        format: "format",
        indentFromTick: "indentFromTick",
        overlappingBehavior: "overlappingBehavior",
        useRangeColors: "useRangeColors",
        visible: "visible"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeLabelComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeLabelModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeLabelModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeLoadingIndicatorComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeLoadingIndicatorComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    showChange;
    get _optionPath() {
      return 'loadingIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'showChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeLoadingIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeLoadingIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeLoadingIndicatorComponent,
      selectors: [["dxo-linear-gauge-loading-indicator"]],
      inputs: {
        backgroundColor: "backgroundColor",
        font: "font",
        show: "show",
        text: "text"
      },
      outputs: {
        showChange: "showChange"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeLoadingIndicatorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeLoadingIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeLoadingIndicatorModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeLoadingIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeLoadingIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeLoadingIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeLoadingIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeLoadingIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeMarginComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeMarginComponent extends NestedOption {
    get bottom() {
      return this._getOption('bottom');
    }
    set bottom(value) {
      this._setOption('bottom', value);
    }
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get right() {
      return this._getOption('right');
    }
    set right(value) {
      this._setOption('right', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'margin';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeMarginComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeMarginComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeMarginComponent,
      selectors: [["dxo-linear-gauge-margin"]],
      inputs: {
        bottom: "bottom",
        left: "left",
        right: "right",
        top: "top"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeMarginComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeMarginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeMarginModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeMarginModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeMarginModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeMarginModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeMarginModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeMarginModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeMinorTickComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeMinorTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'minorTick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeMinorTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeMinorTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeMinorTickComponent,
      selectors: [["dxo-linear-gauge-minor-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeMinorTickComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeMinorTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeMinorTickModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeMinorTickModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeMinorTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeMinorTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeMinorTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeMinorTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiLinearGaugeRangeComponent = /*#__PURE__*/(() => {
  class DxiLinearGaugeRangeComponent extends CollectionNestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    get _optionPath() {
      return 'ranges';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiLinearGaugeRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiLinearGaugeRangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiLinearGaugeRangeComponent,
      selectors: [["dxi-linear-gauge-range"]],
      inputs: {
        color: "color",
        endValue: "endValue",
        startValue: "startValue"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiLinearGaugeRangeComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiLinearGaugeRangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiLinearGaugeRangeModule = /*#__PURE__*/(() => {
  class DxiLinearGaugeRangeModule {
    /** @nocollapse */static ɵfac = function DxiLinearGaugeRangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiLinearGaugeRangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiLinearGaugeRangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiLinearGaugeRangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeRangeContainerComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeRangeContainerComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get horizontalOrientation() {
      return this._getOption('horizontalOrientation');
    }
    set horizontalOrientation(value) {
      this._setOption('horizontalOrientation', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    get paletteExtensionMode() {
      return this._getOption('paletteExtensionMode');
    }
    set paletteExtensionMode(value) {
      this._setOption('paletteExtensionMode', value);
    }
    get ranges() {
      return this._getOption('ranges');
    }
    set ranges(value) {
      this._setOption('ranges', value);
    }
    get verticalOrientation() {
      return this._getOption('verticalOrientation');
    }
    set verticalOrientation(value) {
      this._setOption('verticalOrientation', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'rangeContainer';
    }
    get rangesChildren() {
      return this._getOption('ranges');
    }
    set rangesChildren(value) {
      this.setChildren('ranges', value);
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeRangeContainerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeRangeContainerComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeRangeContainerComponent,
      selectors: [["dxo-linear-gauge-range-container"]],
      contentQueries: function DxoLinearGaugeRangeContainerComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DxiLinearGaugeRangeComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rangesChildren = _t);
        }
      },
      inputs: {
        backgroundColor: "backgroundColor",
        horizontalOrientation: "horizontalOrientation",
        offset: "offset",
        palette: "palette",
        paletteExtensionMode: "paletteExtensionMode",
        ranges: "ranges",
        verticalOrientation: "verticalOrientation",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeRangeContainerComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeRangeContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeRangeContainerModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeRangeContainerModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeRangeContainerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeRangeContainerModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeRangeContainerModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeRangeContainerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeScaleComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeScaleComponent extends NestedOption {
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get customMinorTicks() {
      return this._getOption('customMinorTicks');
    }
    set customMinorTicks(value) {
      this._setOption('customMinorTicks', value);
    }
    get customTicks() {
      return this._getOption('customTicks');
    }
    set customTicks(value) {
      this._setOption('customTicks', value);
    }
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get horizontalOrientation() {
      return this._getOption('horizontalOrientation');
    }
    set horizontalOrientation(value) {
      this._setOption('horizontalOrientation', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minorTickInterval() {
      return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value) {
      this._setOption('minorTickInterval', value);
    }
    get scaleDivisionFactor() {
      return this._getOption('scaleDivisionFactor');
    }
    set scaleDivisionFactor(value) {
      this._setOption('scaleDivisionFactor', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get tickInterval() {
      return this._getOption('tickInterval');
    }
    set tickInterval(value) {
      this._setOption('tickInterval', value);
    }
    get verticalOrientation() {
      return this._getOption('verticalOrientation');
    }
    set verticalOrientation(value) {
      this._setOption('verticalOrientation', value);
    }
    get _optionPath() {
      return 'scale';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeScaleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeScaleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeScaleComponent,
      selectors: [["dxo-linear-gauge-scale"]],
      inputs: {
        allowDecimals: "allowDecimals",
        customMinorTicks: "customMinorTicks",
        customTicks: "customTicks",
        endValue: "endValue",
        horizontalOrientation: "horizontalOrientation",
        label: "label",
        minorTick: "minorTick",
        minorTickInterval: "minorTickInterval",
        scaleDivisionFactor: "scaleDivisionFactor",
        startValue: "startValue",
        tick: "tick",
        tickInterval: "tickInterval",
        verticalOrientation: "verticalOrientation"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeScaleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeScaleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeScaleModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeScaleModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeScaleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeScaleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeScaleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeScaleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeShadowComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeShadowComponent extends NestedOption {
    get blur() {
      return this._getOption('blur');
    }
    set blur(value) {
      this._setOption('blur', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'shadow';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeShadowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeShadowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeShadowComponent,
      selectors: [["dxo-linear-gauge-shadow"]],
      inputs: {
        blur: "blur",
        color: "color",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeShadowComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeShadowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeShadowModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeShadowModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeShadowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeShadowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeShadowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeShadowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeSizeComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeSizeComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'size';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeSizeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeSizeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeSizeComponent,
      selectors: [["dxo-linear-gauge-size"]],
      inputs: {
        height: "height",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeSizeComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeSizeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeSizeModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeSizeModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeSizeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeSizeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeSizeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeSizeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeSubtitleComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeSubtitleComponent,
      selectors: [["dxo-linear-gauge-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeSubtitleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeSubtitleModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeSubvalueIndicatorComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeSubvalueIndicatorComponent extends NestedOption {
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get baseValue() {
      return this._getOption('baseValue');
    }
    set baseValue(value) {
      this._setOption('baseValue', value);
    }
    get beginAdaptingAtRadius() {
      return this._getOption('beginAdaptingAtRadius');
    }
    set beginAdaptingAtRadius(value) {
      this._setOption('beginAdaptingAtRadius', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get horizontalOrientation() {
      return this._getOption('horizontalOrientation');
    }
    set horizontalOrientation(value) {
      this._setOption('horizontalOrientation', value);
    }
    get indentFromCenter() {
      return this._getOption('indentFromCenter');
    }
    set indentFromCenter(value) {
      this._setOption('indentFromCenter', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    get secondColor() {
      return this._getOption('secondColor');
    }
    set secondColor(value) {
      this._setOption('secondColor', value);
    }
    get secondFraction() {
      return this._getOption('secondFraction');
    }
    set secondFraction(value) {
      this._setOption('secondFraction', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get spindleGapSize() {
      return this._getOption('spindleGapSize');
    }
    set spindleGapSize(value) {
      this._setOption('spindleGapSize', value);
    }
    get spindleSize() {
      return this._getOption('spindleSize');
    }
    set spindleSize(value) {
      this._setOption('spindleSize', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get verticalOrientation() {
      return this._getOption('verticalOrientation');
    }
    set verticalOrientation(value) {
      this._setOption('verticalOrientation', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'subvalueIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeSubvalueIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeSubvalueIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeSubvalueIndicatorComponent,
      selectors: [["dxo-linear-gauge-subvalue-indicator"]],
      inputs: {
        arrowLength: "arrowLength",
        backgroundColor: "backgroundColor",
        baseValue: "baseValue",
        beginAdaptingAtRadius: "beginAdaptingAtRadius",
        color: "color",
        horizontalOrientation: "horizontalOrientation",
        indentFromCenter: "indentFromCenter",
        length: "length",
        offset: "offset",
        palette: "palette",
        secondColor: "secondColor",
        secondFraction: "secondFraction",
        size: "size",
        spindleGapSize: "spindleGapSize",
        spindleSize: "spindleSize",
        text: "text",
        type: "type",
        verticalOrientation: "verticalOrientation",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeSubvalueIndicatorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeSubvalueIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeSubvalueIndicatorModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeSubvalueIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeSubvalueIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeSubvalueIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeSubvalueIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeSubvalueIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeTextComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeTextComponent extends NestedOption {
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get indent() {
      return this._getOption('indent');
    }
    set indent(value) {
      this._setOption('indent', value);
    }
    get _optionPath() {
      return 'text';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeTextComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeTextComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeTextComponent,
      selectors: [["dxo-linear-gauge-text"]],
      inputs: {
        customizeText: "customizeText",
        font: "font",
        format: "format",
        indent: "indent"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeTextComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeTextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeTextModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeTextModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeTextModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeTextModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeTextModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeTextModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeTickComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'tick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeTickComponent,
      selectors: [["dxo-linear-gauge-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeTickComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeTickModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeTickModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeTitleComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeTitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeTitleComponent,
      selectors: [["dxo-linear-gauge-title"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        text: "text",
        textOverflow: "textOverflow",
        verticalAlignment: "verticalAlignment",
        wordWrap: "wordWrap"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeTitleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeTitleModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeTitleModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeTooltipComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeTooltipComponent extends NestedOption {
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get interactive() {
      return this._getOption('interactive');
    }
    set interactive(value) {
      this._setOption('interactive', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get zIndex() {
      return this._getOption('zIndex');
    }
    set zIndex(value) {
      this._setOption('zIndex', value);
    }
    get _optionPath() {
      return 'tooltip';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeTooltipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeTooltipComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeTooltipComponent,
      selectors: [["dxo-linear-gauge-tooltip"]],
      inputs: {
        arrowLength: "arrowLength",
        border: "border",
        color: "color",
        container: "container",
        contentTemplate: "contentTemplate",
        cornerRadius: "cornerRadius",
        customizeTooltip: "customizeTooltip",
        enabled: "enabled",
        font: "font",
        format: "format",
        interactive: "interactive",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        shadow: "shadow",
        zIndex: "zIndex"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeTooltipComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeTooltipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeTooltipModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeTooltipModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeTooltipModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeTooltipModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeTooltipModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeTooltipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeValueIndicatorComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeValueIndicatorComponent extends NestedOption {
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get baseValue() {
      return this._getOption('baseValue');
    }
    set baseValue(value) {
      this._setOption('baseValue', value);
    }
    get beginAdaptingAtRadius() {
      return this._getOption('beginAdaptingAtRadius');
    }
    set beginAdaptingAtRadius(value) {
      this._setOption('beginAdaptingAtRadius', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get horizontalOrientation() {
      return this._getOption('horizontalOrientation');
    }
    set horizontalOrientation(value) {
      this._setOption('horizontalOrientation', value);
    }
    get indentFromCenter() {
      return this._getOption('indentFromCenter');
    }
    set indentFromCenter(value) {
      this._setOption('indentFromCenter', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    get secondColor() {
      return this._getOption('secondColor');
    }
    set secondColor(value) {
      this._setOption('secondColor', value);
    }
    get secondFraction() {
      return this._getOption('secondFraction');
    }
    set secondFraction(value) {
      this._setOption('secondFraction', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get spindleGapSize() {
      return this._getOption('spindleGapSize');
    }
    set spindleGapSize(value) {
      this._setOption('spindleGapSize', value);
    }
    get spindleSize() {
      return this._getOption('spindleSize');
    }
    set spindleSize(value) {
      this._setOption('spindleSize', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get verticalOrientation() {
      return this._getOption('verticalOrientation');
    }
    set verticalOrientation(value) {
      this._setOption('verticalOrientation', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'valueIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeValueIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeValueIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeValueIndicatorComponent,
      selectors: [["dxo-linear-gauge-value-indicator"]],
      inputs: {
        arrowLength: "arrowLength",
        backgroundColor: "backgroundColor",
        baseValue: "baseValue",
        beginAdaptingAtRadius: "beginAdaptingAtRadius",
        color: "color",
        horizontalOrientation: "horizontalOrientation",
        indentFromCenter: "indentFromCenter",
        length: "length",
        offset: "offset",
        palette: "palette",
        secondColor: "secondColor",
        secondFraction: "secondFraction",
        size: "size",
        spindleGapSize: "spindleGapSize",
        spindleSize: "spindleSize",
        text: "text",
        type: "type",
        verticalOrientation: "verticalOrientation",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeValueIndicatorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeValueIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeValueIndicatorModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeValueIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeValueIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeValueIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeValueIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeValueIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoLinearGaugeWidthComponent = /*#__PURE__*/(() => {
  class DxoLinearGaugeWidthComponent extends NestedOption {
    get end() {
      return this._getOption('end');
    }
    set end(value) {
      this._setOption('end', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get _optionPath() {
      return 'width';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoLinearGaugeWidthComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeWidthComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoLinearGaugeWidthComponent,
      selectors: [["dxo-linear-gauge-width"]],
      inputs: {
        end: "end",
        start: "start"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoLinearGaugeWidthComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoLinearGaugeWidthComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoLinearGaugeWidthModule = /*#__PURE__*/(() => {
  class DxoLinearGaugeWidthModule {
    /** @nocollapse */static ɵfac = function DxoLinearGaugeWidthModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoLinearGaugeWidthModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoLinearGaugeWidthModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoLinearGaugeWidthModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiLinearGaugeRangeComponent, DxiLinearGaugeRangeModule, DxoLinearGaugeAnimationComponent, DxoLinearGaugeAnimationModule, DxoLinearGaugeBackgroundColorComponent, DxoLinearGaugeBackgroundColorModule, DxoLinearGaugeBorderComponent, DxoLinearGaugeBorderModule, DxoLinearGaugeColorComponent, DxoLinearGaugeColorModule, DxoLinearGaugeExportComponent, DxoLinearGaugeExportModule, DxoLinearGaugeFontComponent, DxoLinearGaugeFontModule, DxoLinearGaugeFormatComponent, DxoLinearGaugeFormatModule, DxoLinearGaugeGeometryComponent, DxoLinearGaugeGeometryModule, DxoLinearGaugeLabelComponent, DxoLinearGaugeLabelModule, DxoLinearGaugeLoadingIndicatorComponent, DxoLinearGaugeLoadingIndicatorModule, DxoLinearGaugeMarginComponent, DxoLinearGaugeMarginModule, DxoLinearGaugeMinorTickComponent, DxoLinearGaugeMinorTickModule, DxoLinearGaugeRangeContainerComponent, DxoLinearGaugeRangeContainerModule, DxoLinearGaugeScaleComponent, DxoLinearGaugeScaleModule, DxoLinearGaugeShadowComponent, DxoLinearGaugeShadowModule, DxoLinearGaugeSizeComponent, DxoLinearGaugeSizeModule, DxoLinearGaugeSubtitleComponent, DxoLinearGaugeSubtitleModule, DxoLinearGaugeSubvalueIndicatorComponent, DxoLinearGaugeSubvalueIndicatorModule, DxoLinearGaugeTextComponent, DxoLinearGaugeTextModule, DxoLinearGaugeTickComponent, DxoLinearGaugeTickModule, DxoLinearGaugeTitleComponent, DxoLinearGaugeTitleModule, DxoLinearGaugeTooltipComponent, DxoLinearGaugeTooltipModule, DxoLinearGaugeValueIndicatorComponent, DxoLinearGaugeValueIndicatorModule, DxoLinearGaugeWidthComponent, DxoLinearGaugeWidthModule };
